<template>

	<div>
		<CoolLightBox
			:items="medias"
			:index="index"
			:loop="true"
			:gallery="false"
			:effect="'swipe'"
			:slideshow="false"
			@close="index = null">

			<svg slot="icon-previous" class="ticon ticon-180"><use xlink:href="/images/icons.svg#icon-arrow-right"></use></svg>
			<svg slot="close" class="ticon"><use xlink:href="/images/icons.svg#icon-close"></use></svg>
			<svg slot="icon-next" class="ticon"><use xlink:href="/images/icons.svg#icon-arrow-right"></use></svg>
		</CoolLightBox>
			<div class="product-single--thumbnails row d-lg-flex d-block">
				<flickity
					ref="flickity"
					:options="flickityOptions"
				>
					<div class="col-md-6 mb-2 thumbnail-single" v-for="(media, mediaidx) in medias" :key="mediaidx">
						<div class="main-img" v-if="mediaidx == 0" >
							<img loading="lazy" :src="media.src" :alt="media.name" class="img-fluid" @click="setIndex(mediaidx)">

							<span v-text="$__('product.more_images')"></span>
						</div>
						<div class="thumb-img" v-else-if="mediaidx > 0 && mediaidx <= maxImages">
							<img loading="lazy" :src="media.src" :alt="media.name" class="img-fluid" @click="setIndex(mediaidx)">
						</div>
						<div class="flickity-info">
							{{ mediaidx+1 }}/{{ medias.length }}
						</div>
					</div>
				</flickity>
			</div>
	</div>

</template>
<script>

import Flickity from './Flickity.vue';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import 'flickity-imagesloaded';

export default {
	name: 'ProductGallery',
	components: {
		Flickity,
		CoolLightBox
	},
	props: {
		medias: Array,
		main_image: String
	},
	data () {
		return {
			index: null,

			flickityOptions: {
				contain: true,
				pageDots: true,
				prevNextButtons: false,
				wrapAround: true,
				imagesLoaded: true,
				adaptiveHeight: true,
				setGallerySize: true,
				cellAlign: 'left',
				watchCSS: true

			},
			windowWidth: null
		}
	},
	methods: {
		setIndex(index) {
			this.index = index
		},

		slidesLoaded () {
			this.$nextTick(() => {
				setTimeout(() => this.$refs.flickity.resize(),1000);
			});
		},
	},
	computed: {
		maxImages() {
			if (this.windowWidth <= 768) {
				return 100;
			}
			return 2
		}
	},

	created() {
		this.medias.unshift({src: this.main_image});
	},
	mounted() {
		this.windowWidth = window.innerWidth
		this.slidesLoaded();
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth
		})
	}
}

</script>
